import { useMemo } from 'react';
import {
  FilterToolbarItem,
  FilterToolbarItemId,
  SelectedFilters,
} from 'src/components/Filters';
import { FiltersList } from 'src/components/FilterToolbar/FilterDialogV2/FiltersList/FiltersList';
import { FiltersListProp } from 'src/components/FilterToolbar/FilterDialogV2/FiltersList/FiltersList.types';

import { ActionToAllFilters } from './ActionToAllFilters';

export const EventSelectedFilters = ({
  tempQuery,
  selectedDropdownItems,
  filters,
  onFilterRemoved,
  onSaveSelectedFilters,
}: Pick<
  FiltersListProp,
  'filters' | 'selectedDropdownItems' | 'tempQuery' | 'onFilterRemoved'
> & { onSaveSelectedFilters: (_: SelectedFilters) => void }) => {
  const filtersMap = useMemo<
    Partial<Record<FilterToolbarItemId, FilterToolbarItem>>
  >(() => {
    const filtersMap: Partial<Record<FilterToolbarItemId, FilterToolbarItem>> =
      {};
    filters.forEach((filterGroup) => {
      filterGroup.items.forEach((filterItem) => {
        filtersMap[filterItem.filterId] = filterItem;
      });
    });
    return filtersMap;
  }, [filters]);

  return (
    <>
      <FiltersList
        filters={filters}
        selectedDropdownItems={selectedDropdownItems}
        tempQuery={tempQuery}
        filtersMap={filtersMap}
        onFilterRemoved={onFilterRemoved}
        mandatoryFiltersToShow={[]}
        listView
      />
      <ActionToAllFilters
        hasFilters
        selectedFilters={selectedDropdownItems}
        filters={filters}
        onSaveSelectedFilters={onSaveSelectedFilters}
      />
    </>
  );
};
